import { Input } from "common/InputForm";
import useButtonLoader from "common/UseButtonLoader";
import { CustomButton } from "components/form";
import React, { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { forgetApi } from "services/auth";
import commonMessages from "utils/commonMessage";
import { regex } from "utils/formValidator";
import { toastMessage } from "utils/toastMessage";

const ForgotPassword = ({ data, setData, setSteps }) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Send Otp");
  const [error, setError] = useState("");
  const { EMAIL_NOT_FOUND, VALID_EMAIL } = commonMessages;
  const { email } = regex;

  const validation = () => {
    let status = true;
    if (!data.email) {
      setError(EMAIL_NOT_FOUND);
      status = false;
    } else if (!data.email.match(email)) {
      setError(VALID_EMAIL);
      status = false;
    }
    return status;
  };

  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const forgetPasswordHandler = async () => {
    if (validation()) {
      try {
        setButtonLoader(true);
        const res = await forgetApi(data);
        if (res?.data?.status === 200) {
          setSteps(5);
          toastMessage(res?.data?.message, "success", "forgotPassword", 10000);
          setData({ email: data.email });
        } 
      } catch (e) {
        console.log("error", e);
      } finally {
        setButtonLoader(false);
      }
    }
  };


  return (
    <>
      <form className="forgot_password">
        <div className="back_button">
          <button
            type="button"
            onClick={() => {
              setSteps(1);
              setData({});
            }}
          >
            <IoIosArrowBack /> Back to login
          </button>
        </div>

        <div className="form_title">
          <h2>Forgot Password?</h2>
          <p>
            No worries, we've got you covered! Enter your
            email address below and we'll send you a otp to reset your
            password.
          </p>
        </div>
        <div className="form_field">
          {/* <label className="label">Email Address</label>
          <input
            type="email"
            className="form-control input"
            placeholder="Enter email address"
          /> */}
          <Input
            className={"form-control input"}
            type={"email"}
            value={data.email}
            onChange={onChangeHandler}
            label={"Email Address"}
            placeholder={"Enter email address"}
            name={"email"}
            error={error}
          />
        </div>
        <div className="button_wrap button_right">
          <CustomButton
            type="button"
            className="button w-100"
            onClick={forgetPasswordHandler}
            ref={buttonLoader}
          >
            Send Otp
          </CustomButton>
        </div>
      </form>
    </>
  );
};

export default ForgotPassword;
